<div id="imgLightBox" class="slide-modal">
  <span class="close cursor" (click)="closeimgLightBox()">&times;</span>
  <div class="slide-modal-content" >

    <img id="imgLightBoxSrc" src="" class="img-content">

  </div>
</div>
